// Vendor
import MicroModal from 'micromodal'

// Components
import Carousel from './components/carousel'
import Cards from './components/cards'
import Faq from './components/faq'
import Lazy from './components/lazy'
import Loader from './components/loader'
import Map from './components/map'
import Mobile from './components/mobile'
import Scrollspy from './components/scrollspy'
import Tabs from './components/tabs'
import Video from './components/video'

// Document loaded
document.addEventListener('DOMContentLoaded', function () {
    initComponent('.header-nav', element => new Mobile(element))
    initComponent('.splide', element => new Carousel(element))
    initComponent('.video', element => new Video(element))
    initComponent('.faq', element => new Faq(element))
    initComponent('.map', element => new Map(element))
    initComponent('.loader', element => new Loader(element))
    initComponent('.lazy-video', element => new Lazy(element))
    initComponent('.scrollspy', element => new Scrollspy(element))
    initComponent('.case-cards', element => new Cards(element))
    initComponent('.tabs', element => new Tabs(element))
});

MicroModal.init({
    onClose: modal => closeVideo(modal),
});

// Helper to close a video in an element
function closeVideo(modal) {
    const element = modal.querySelector(".video");
    const video = modal.querySelector("video");

    if (video) {
        element.classList.remove("playing") 
        video.pause();
    }
}

// Global helper to find and initialize components
function initComponent(selector, callback) {
    const elements = document.querySelectorAll(selector)
    elements.forEach(function (element) {
        callback(element)
    });
}


/* ===== blog page script Logic for creating fake Select Boxes ===== */
jQuery('.sel').each(function() {
    jQuery(this).children('select').css('display', 'none');

    var jQuerycurrent = jQuery(this);

jQuery(this).find('option').each(function(i) {
    if (i == 0) {
        jQuerycurrent.prepend(jQuery('<div>', {
        class: jQuerycurrent.attr('class').replace(/sel/g, 'sel__box')
    }));
    
    var placeholder = jQuery(this).text();
    jQuerycurrent.prepend(jQuery('<span>', {
        class: jQuerycurrent.attr('class').replace(/sel/g, 'sel__placeholder'),
        text: placeholder,
        'data-placeholder': placeholder
    }));
    
    return;
    }
    
    jQuerycurrent.children('div').append(jQuery('<span>', {
    class: jQuerycurrent.attr('class').replace(/sel/g, 'sel__box__options'),
    text: jQuery(this).text()
    }));
});
});

// Toggling the .active state on the `.sel`.
jQuery('.sel').click(function() {
    jQuery(this).toggleClass('active');
});

// Toggling the .selected state on the options.
jQuery('.sel__box__options').click(function() {
    var txt = jQuery(this).text();
    var index = jQuery(this).index();

    jQuery(this).siblings('.sel__box__options').removeClass('selected');
    jQuery(this).addClass('selected');

var jQuerycurrentSel = jQuery(this).closest('.sel');
    jQuerycurrentSel.children('.sel__placeholder').text(txt);
    jQuerycurrentSel.children('select').prop('selectedIndex', index + 1);
	jQuery("#searchcat").submit();
});

// show hide elements
jQuery("#showcat-1").click(function(){
    jQuery(".banner-00").hide();
    jQuery(".banner-01").show();
});

